import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { ExitInterviewResponses } from "../../shared/models/ExitInterviews";
import { Offboarding } from "../../shared/models/Offboarding";

@Component({
  selector: "app-exit-emp-form",
  templateUrl: "./exit-emp-form.component.html",
  styleUrls: ["./exit-emp-form.component.css"],
})
export class ExitEmpFormComponent implements OnInit {
  @Output("employeeOff") employeeOff = new EventEmitter();
  QuestionList: any;
  LoginEmpCode: any;
  SaveList: any;
  SubmitList: any;
  dataSourceFTE: MatTableDataSource<ExitInterviews>;
  exitInterviews: ExitInterviews[];
  exitInterviewResponses: ExitInterviewResponses;
  error: string;
  result: any;
  offboardingList: any;
  offboardingLWD: any;
  ResponseList: any;
  isSubmitVisible: boolean = false;
  isCommentsDisabled: boolean = false;
  isLWD = true;

  constructor(
    private empsvc: EmployeeService,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private _userService: UserService
  ) {
    this.QuestionList = [];
    this.dataSourceFTE = new MatTableDataSource();
  }
  displayedColumns: string[] = [
    "Id",
    "Question",
    "CreatedBy",
    "Edit",
    "Delete",
  ];
 

  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  @ViewChild("input", { static: false }) input: ElementRef;
  
  check: boolean = false;
  isLoader: boolean = true;

  ngOnInit() {
    this.LoginEmpCode = this._userService.getEmpCode();
    this.getExitQuestions();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
    this.getExitInterviewResponses();
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }


  getExitQuestions() {
    this.empsvc.getEmpFeedbackComments(this.LoginEmpCode).subscribe(
      (data: ExitInterviews[]) => {
        this.QuestionList = data;
        this.dataSourceFTE.data = this.QuestionList;
        if (this.paginatorFTE) {
          this.dataSourceFTE.paginator = this.paginatorFTE; 
        }
        if (this.sortFTE) {
          this.dataSourceFTE.sort = this.sortFTE; 
        }
      },
      error => {
        console.error('Error fetching exit interview questions', error);
        this.toastr.error('Failed to load questions');
      }
    );
  }

  SaveEmployeeResponses() {
    const message = "Are you sure you want to save exit interview response/s?";
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.isLoader = true;
        const responses: ExitInterviews[] = this.QuestionList.map(element => ({
          Id: element.Id,
          OffboardingId: element.OffboardingId, 
          EmpCode: this.LoginEmpCode,
          Question: element.Question,
          EmployeeComments: element.EmployeeComments,
          CreatedBy: '', 
          CreatedDate: new Date(), 
          ModifiedBy: '',
          ModifiedDate: null, 
          IsEmpFeedbackSubmitted: false 
        }));
        this.empsvc.saveExitInterviewResponses(responses).subscribe(
          (data) => {
            this.SaveList = data;
            const message = "Response/s Saved Successfully";
            this.toastr.success(message);
            //this.isLoader = false;
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.isLoader = false;
            }, 1000);
          },
          (error) => {
            this.error = error;
            this.isLoader = false;
            this.toastr.error("Error saving question.");
          }
        );
      }
    }, (error) => {
      this.isLoader = false;
      this.result = error;
    });
  }

  SubmitEmployeeResponses() {
    const allResponsesFilled = this.QuestionList.every(element =>
      element.EmployeeComments !== null && element.EmployeeComments.trim() !== ''
    );

    if (!allResponsesFilled) {
      this.toastr.error("Please fill all responses before submission");
      return; 
    }
    const message = "Please click OK to submit the responses. Your responses cannot be edited once you submit it.";
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.isLoader = true;
        const responses: ExitInterviews[] = this.QuestionList.map(element => ({
          Id: element.Id,
          OffboardingId: element.OffboardingId, 
          EmpCode: this.LoginEmpCode,
          Question: element.Question,
          EmployeeComments: element.EmployeeComments,
          CreatedBy: '', 
          CreatedDate: new Date(), 
          ModifiedBy: '', 
          ModifiedDate: null, 
          IsEmpFeedbackSubmitted: true
        }));
        this.empsvc.saveExitInterviewResponses(responses).subscribe(
          (data) => {
            this.SubmitList = data;
            const message = "Responses Submitted Successfully";
            this.toastr.success(message);
            this.isLoader = false;
            this.isSubmitVisible = false;
            this.isCommentsDisabled = true;
            //window.scrollTo(0, 0);
            //setTimeout(() => {
            //  this.isLoader = false;
            //}, 1000);
          },
          (error) => {
            this.error = error;
            this.isLoader = false;
            this.toastr.error("Error saving question.");
          }
        );
      }
    }, (error) => {
      this.isLoader = false;
      this.result = error;
    });
  }

  getExitInterviewResponses() {
    this.empsvc.getExitInterviewHistory(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.ResponseList = data;
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const lwd = this.ResponseList.LastWorkingDay ? new Date(this.ResponseList.LastWorkingDay) : null;
        if (lwd) {
          lwd.setHours(0, 0, 0, 0);
        }

        //console.log(lwd)
        const isLwdOver = lwd && currentDate > lwd;

      

        if (this.ResponseList && this.ResponseList.IsEmpFeedbackSubmitted) {
          this.isSubmitVisible = false; 
          this.isCommentsDisabled = true; 
        }
        else if (this.ResponseList && isLwdOver) {
          this.isSubmitVisible = false;
          this.isCommentsDisabled = true;
        }
        else {
          this.isSubmitVisible = true; 
          this.isCommentsDisabled = false;       
        }
      });
  }

}

